import classNames from "classnames";
import FieldError from "pages/_components/fields/FieldError";
import FieldLabel from "pages/_components/fields/FieldLabel";
import withFocus from "pages/_components/withFocus";
import Select from "pages/forms/_components/_fields/Select";
import RadioButtonGroup from "pages/forms/_components/_fields/_commons/RadioButtonGroup";
import { any, arrayOf, bool, func, objectOf, oneOfType, shape, string } from "prop-types";
import React, { Component } from "react";
import * as i18n from "util/i18n";

class Selector extends Component {
    static propTypes = {
        className: string,
        disabled: bool,
        field: shape({ name: string }).isRequired,
        form: shape({
            errors: objectOf(oneOfType([string, objectOf(string)])),
            touched: objectOf(oneOfType([arrayOf(bool), bool, objectOf(bool)])),
        }).isRequired,
        handleChange: func,
        idForm: string.isRequired,
        inLineControl: bool,
        isFocused: bool,
        labelNoMarginTop: bool,
        labelText: string,
        options: arrayOf(objectOf(any)).isRequired,
        placeholder: string,
        renderAs: string,
        searchable: bool,
        value: string,
        noLabel: bool,
        column: bool,
        gap: string,
        multi: bool,
        formGroupClassName: string,
        errorWithOutTouched: bool,
        forceValue: bool,
    };

    static defaultProps = {
        className: null,
        disabled: false,
        handleChange: null,
        inLineControl: false,
        isFocused: false,
        labelNoMarginTop: false,
        labelText: null,
        placeholder: null,
        renderAs: "combo",
        searchable: false,
        value: null,
        noLabel: false,
        column: false,
        gap: null,
        multi: false,
        formGroupClassName: null,
        errorWithOutTouched: false,
        forceValue: false,
    };

    handleChange = (param) => {
        const { field, form, renderAs, handleChange } = this.props;
        let valueParam = param;

        if (renderAs === "combo") {
            const { value } = param;
            valueParam = value;
        }

        form.setFieldValue(field.name, valueParam);

        if (handleChange) {
            handleChange(valueParam);
        }

        if (field.name in form.errors) {
            const { [field.name]: error, ...rest } = form.errors;
            form.setErrors(rest);
        }
    };

    renderAsRadio() {
        const {
            options,
            form,
            field,
            isFocused,
            inLineControl,
            column,
            gap,
            disabled,
            formGroupClassName,
            errorWithOutTouched,
        } = this.props;
        const { touched, errors } = form;
        const hasError = errorWithOutTouched ? errors[field.name] : touched[field.name] && errors[field.name];

        return (
            <fieldset
                className={classNames("form-group", formGroupClassName, {
                    "has-error": hasError,
                    "has-focus": isFocused,
                })}>
                <RadioButtonGroup
                    inLineControl={inLineControl}
                    name={field.name}
                    selectorId={field.name}
                    onChange={this.handleChange}
                    options={options}
                    value={field.value}
                    column={column}
                    gap={gap}
                    disabled={disabled}
                />
                {hasError && <FieldError error={errors[field.name]} />}
            </fieldset>
        );
    }

    renderAsCombo() {
        const {
            disabled,
            field,
            form,
            idForm,
            isFocused,
            labelNoMarginTop,
            labelText,
            options,
            placeholder,
            searchable,
            value,
            noLabel,
            multi,
            formGroupClassName,
            errorWithOutTouched,
            forceValue,
        } = this.props;
        const { touched, errors } = form;
        const { name } = field;
        const hasError = errorWithOutTouched ? errors[field.name] : touched[field.name] && errors[field.name];

        const ph = placeholder != null ? placeholder : i18n.get(`${idForm}.${field.name}.placeholder`);

        return (
            <div
                className={classNames("form-group", formGroupClassName, {
                    "has-error": hasError,
                    "has-focus": isFocused,
                })}>
                {!noLabel && (
                    <FieldLabel
                        idField={`react-select-${field.name}-input`}
                        {...(labelText ? { labelText } : { labelKey: `${idForm}.${field.name}.label` })}
                        labelNoMarginTop={labelNoMarginTop}
                    />
                )}

                <div className="input-group">
                    <Select
                        id={field.name}
                        searchable={searchable}
                        onChange={this.handleChange}
                        clearable={false}
                        name={name}
                        value={field.value && !forceValue ? field.value : value}
                        options={options}
                        placeholder={ph}
                        disabled={disabled}
                        valueKey="value"
                        multi={multi}
                    />
                </div>
                {hasError && <FieldError error={errors[field.name]} />}
            </div>
        );
    }

    render() {
        const { renderAs } = this.props;

        if (renderAs === "combo") {
            return this.renderAsCombo();
        }
        if (renderAs === "radio") {
            return this.renderAsRadio();
        }

        return null;
    }
}

export default withFocus(Selector);
